import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getSpecificDetails } from "../../service/ApiService";
import { TAX_LIST_DETAIL } from "../../config/ApiConstant";
import { Toast } from "primereact/toast";
import { Section } from "../../components/CommonCompentUi";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { WalletCards } from "lucide-react";
import { TaxPayerPaymentDoneColumns } from "../../appconfig/DatatableSetting";
import Loader from "../../components/Loader/Loader";
import { amountTemplate, dateTemplate } from "../../appconfig/TemplateFieldSetting";

interface TaxPayerPaymentDoneProps {
  data?: any;
  loading?: boolean;
  refreshData?: () => void;
}

const TaxPayerPaymentDone = ({ data, loading, refreshData }: TaxPayerPaymentDoneProps) => {

  // tax payer id
  const { id }: any = useParams();
  const employee_id = id ? atob(id) : null;

  // toast ref
  const toast = useRef<any>(null);

  // tax payer detail obj
  const [userTaxFileData, setUserTaxFileData] = useState<any>(null);

  // document list
  const [paymentList, setPaymentList] = useState<any>([]);

  // page load
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  //   filter
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);

  // scroll position
  const scrollPositionRef = useRef(0);

  // Collapsible sections state
  const [expandedSections, setExpandedSections] = useState<any>({
    documents: true,
  });

  //   serial no state
  const [first, setFirst] = useState(0);

  // useEffect to parse tax payer detail when and data changes
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      parseTaxData(data);
    }
  }, [data]);

  // Handle scroll position in tab
  useLayoutEffect(() => {
    window.scrollTo({
      top: scrollPositionRef.current,
      behavior: "auto",
    });
  }, [expandedSections]);

  // get Tax payer detail
  const parseTaxData = (response: any) => {
    const paymentData = response?.payment_data;
    setUserTaxFileData(response);
    setPaymentList(paymentData);

    setPageLoad(true);
  };

  // serial no template
  const serialNoBodyTemplate = (_: any, options: any) => {
    return first + options.rowIndex + 1;
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="tax-payer-modern-container">
        <div className="content-wrapper">
          {/* Payments */}
          <Section
            title="Payments"
            icon={WalletCards}
            sectionKey="documents"
            scrollPositionRef={scrollPositionRef}
            expandedSections={expandedSections}
            setExpandedSections={setExpandedSections}
            className="crud-demo"
          >
            <div className="mt-4">
              {pageLoad ? (
                <>
                  <div className="crud-demo">
                    <DataTable
                      value={paymentList}
                      showGridlines
                      dataKey="id"
                      stripedRows
                      responsiveLayout="scroll"
                      globalFilter={globalFilter}
                      rows={defaultRowOptions}
                      paginator={paymentList.length > 0}
                      rowsPerPageOptions={defaultPageRowOptions}
                      className="datatable-responsive p-datatble-sm "
                      paginatorTemplate={paginatorLinks}
                      currentPageReportTemplate={showingEntries + " Payments"}
                      emptyMessage="No Payment Found"
                      filters={globalFieldFilter}
                      onFilter={(e) => setGlobalFieldFilter(e.filters)}
                      removableSort
                      //   serial no
                      first={first}
                      onPage={(e) => setFirst(e.first)}
                    >
                      <Column header="S.No" body={serialNoBodyTemplate} style={{ width: "80px", textAlign: "center" }} />
                      {TaxPayerPaymentDoneColumns.map((col) => {
                        if (col.field === "createdAt") {
                          return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                        } else if (col.field === "amount") {
                          return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                        }
                        return <Column key={col.field} field={col.field} header={col.header} />;
                      })}
                    </DataTable>
                  </div>
                </>
              ) : (
                <div className="crud-demo">
                  <DataTable value={Skeletonitems}>
                    {TaxPayerPaymentDoneColumns.map((col) => (
                      <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                    ))}
                  </DataTable>
                </div>
              )}
            </div>
          </Section>
        </div>
      </div>

      {/* {pageLoad === false && <Loader />} */}
    </>
  );
};

export default TaxPayerPaymentDone;
